var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiSoftwareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 24H14.5M14.5 24H18.6667M14.5 24V19.875M14.5 19.875H24.2222C24.9589 19.875 25.6655 19.5853 26.1864 19.0695C26.7073 18.5538 27 17.8543 27 17.125V4.75C27 4.02065 26.7073 3.32118 26.1864 2.80546C25.6655 2.28973 24.9589 2 24.2222 2H4.77778C4.04107 2 3.33453 2.28973 2.81359 2.80546C2.29266 3.32118 2 4.02065 2 4.75V17.125C2 17.8543 2.29266 18.5538 2.81359 19.0695C3.33453 19.5853 4.04107 19.875 4.77778 19.875H14.5Z",
    stroke: "#674366",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSoftwareIcon);
export default __webpack_public_path__ + "static/media/ai_software_icon.d6a0bd8db57cda834eca339ef8f18e58.svg";
export { ForwardRef as ReactComponent };